var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgContactEmail = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5H28C38.7696 0.5 47.5 9.23045 47.5 20V28C47.5 38.7696 38.7696 47.5 28 47.5H20C9.23045 47.5 0.5 38.7696 0.5 28V20Z",
    fill: "white",
    stroke: "#DDE2EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2859 28.9989V20.4275C33.2859 20.4275 24.6192 26.4751 23.7764 26.7889C22.9478 26.4894 14.2383 20.4275 14.2383 20.4275V28.9989C14.2383 30.1894 14.4907 30.4275 15.6669 30.4275H31.8573C33.0616 30.4275 33.2859 30.2184 33.2859 28.9989ZM33.2721 18.747C33.2721 17.8798 33.0192 17.5703 31.8573 17.5703H15.6669C14.4716 17.5703 14.2383 17.9417 14.2383 18.8084L14.2526 18.9417C14.2526 18.9417 22.8569 24.8656 23.7764 25.1894C24.7478 24.8132 33.2859 18.8084 33.2859 18.8084L33.2721 18.747Z",
    fill: "#03002F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2721 18.747C33.2721 17.8798 33.0192 17.5703 31.8573 17.5703H15.6669C14.4716 17.5703 14.2383 17.9417 14.2383 18.8084L14.2526 18.9417C14.2526 18.9417 22.8569 24.8656 23.7764 25.1894C24.7478 24.8132 33.2859 18.8084 33.2859 18.8084L33.2721 18.747Z",
    fill: "#C59331"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContactEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contactEmail.7b2ed1a6a50a2bf7c786c9e31f7d600e.svg";